var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOpenInNew = function SvgOpenInNew(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12.721,
    height: 12.721,
    viewBox: "0 0 12.721 12.721",
    id: "open-in-new",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "open-in-new",
    d: "M14.307,14.307H4.413V4.413H9.36V3H4.413A1.413,1.413,0,0,0,3,4.413v9.894a1.413,1.413,0,0,0,1.413,1.413h9.894a1.418,1.418,0,0,0,1.413-1.413V9.36H14.307ZM10.774,3V4.413h2.537L6.364,11.36l1,1L14.307,5.41V7.947h1.413V3Z",
    transform: "translate(-3 -3)",
    fill: "#3455db"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOpenInNew, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/open-in-new.c9ba9f18.svg";
export { ForwardRef as ReactComponent };